/**
 * Mutación para modificar los datos del interceptor.
 *
 * @param Object state
 * @param Object next: nuevos datos.
 * @author Fernando Claros
 */
export function setUrlShorter(state, next) {
    state.urlShorter = next
}

/**
 * Mutación para control el estado de carga.
 *
 * @param Object state
 * @param Boolean next: estado de carga.
 * @author Fernando Claros
 */
export function setLoading(state, next) {
    state.loading = next
}